import "vuetify/styles";
import "@socotec.io/socio-vue-components/style.css";
import { createVuetify } from "vuetify";
import { socioVuetifyConfig } from "@socotec.io/socio-vue-components";
import merge from "lodash/merge";

const socioColors = socioVuetifyConfig.theme.themes.light.colors;

const sightVuetifyConfig = {
  theme: {
    themes: {
      light: {
        colors: {
          "priority-p1": "#A3100E",
          "on-priority-p1": socioColors.white,
          "priority-p2": socioColors.yellow,
          "on-priority-p2": "#443C1B",
          "priority-p3": "#339BE5",
          "on-priority-p3": socioColors.white,
        },
        variables: {
          "border-color": socioColors["border-color-root"],
          "border-opacity": 1,
        },
      },
    },
  },
};

export default function createSightVuetify() {
  return createVuetify(merge({}, socioVuetifyConfig, sightVuetifyConfig));
}
